import webAiWidgetRouteGuard from '@/utils/routeGuards/webAIWidgetRouteGuard';
import voiceChannelSettingsRouteGuard from '@/utils/routeGuards/voiceChannelSettingsRouteGuard';

const routes = [
  {
    path: '/online-presence/web-ai-widget',
    name: 'online-presence-web-ai-widget',
    component: () => import(/* webpackChunkName: "WebAIWidgetPage" */ './views/WebAIWidgetPage.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Web AI Widget',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
  {
    path: '/online-presence/web-ai-widget/history/:conversation_uid',
    name: 'online-presence-web-ai-widget-history-conversation',
    component: () => import(/* webpackChunkName: "WebAIWidgetPage" */ './views/WebAIWidgetPage.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Web AI Widget Conversation',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
  {
    path: '/online-presence/web-ai-widget/website-widget-settings',
    name: 'online-presence-website-widget-settings',
    component: () => import(/* webpackChunkName: "WebAIWidgetEditor" */ './views/WebAIWidgetEditor.vue'),
    props: { mode: 'website_widget' },
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Website AI Widget Settings',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
  {
    path: '/online-presence/web-ai-widget/voice-channel-settings/:channel_uid',
    name: 'online-presence-voice-channel-settings',
    component: () => import(/* webpackChunkName: "VoiceChannelSettings" */ './views/VoiceChannelSettings.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Voice Channel Settings',
    },
    beforeEnter: voiceChannelSettingsRouteGuard,
  },
];

export default routes;
